import React from 'react'
import "../styles/Home.css"
import FadeInSection from './FadeIn'
import Typewriter from "typewriter-effect"


function Home() {

  const name_stack = [
    "Cristian",
    "Sanchez",
    "Lopez",
  ];

  // const name_items = name_stack.map(stack => <li>{stack}</li>);

  return (
    <div id='home'>
      <ul className='home-name'>
        {name_stack.map(function (name_item, i) {
          return (
            <FadeInSection key={i} delay={`${i + 2}00ms`}>
              <li>{name_item}</li>
            </FadeInSection>
          );
        })}
      </ul>
      <hr />
      <div className='intro'>
        <div className='typer-container'>
          <Typewriter
            onInit={(typewriter) => {
              typewriter.typeString('Hello there...')
                .start();
            }}
            cursorClassName='Typewriter__cursor'
          />
        </div>
        <FadeInSection>
          <div className='home-intro-title'> I enjoy the <span className='process-word'>process</span> of creation</div>
          <div className='intro-paragraph'>
            Welcome to my portfolio! I am a Web developer based in Hamilton, and I create websites that are like a work of art - engaging, visually stunning, and thoughtfully designed. I have interest in full-stack development and some game development. Take a stroll through my portfolio and let me know what you think. 
          </div>
          <hr className='para-bottom'/>
        </FadeInSection>
      </div>
    </div>
  )
}

export default Home